<template>
  <div>
    <h5>Auto PT Head Reinitialization Config</h5>
    <table
      v-if="configs.length"
      :class="[
        'table kendo-table table-kendo mb-2',
        { 'is-invalid': this.$validator.errors.has('configs') },
      ]"
    >
      <colgroup>
        <col width="35" />
      </colgroup>
      <thead>
        <tr>
          <th>{{ $t("active") }}</th>
          <th>{{ $t("options") }}</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(item, index) in configs"
          :key="`config-tableRow-${index}`"
        >
          <td>
            <toggle-button
              v-model="item.active"
              :width="50"
              :height="24"
              :font-size="12"
              class="m-0"
              @change="update()"
            />
          </td>
          <td>
            <div class="btn-group btn-group-sm flex-wrap">
              <button
                class="btn btn-sm btn-secondary"
                @click="removeItem(index)"
              >
                <font-awesome-icon
                  class="mr-2 gray"
                  icon="trash"
                />
                <span>{{ $t("remove") }}</span>
              </button>
              <button
                class="btn btn-sm btn-secondary"
                @click="moveUp(index)"
              >
                <font-awesome-icon icon="arrow-up" />
              </button>
              <button
                class="btn btn-sm btn-secondary"
                @click="moveDown(index)"
              >
                <font-awesome-icon icon="arrow-down" />
              </button>
              <input
                v-model="item.reinitTimeStart"
                placeholder="07:30"
                type="text"
                style="width: 45px"
                @input="update()"
              />
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <hr v-else />
    <button
      class="btn btn-sm btn-primary float-right"
      @click="addItem()"
    >
      <font-awesome-icon
        class="mr-2"
        icon="plus"
      />
      <span>{{ $t("add") }}</span>
    </button>
    <div class="clearfix" />
  </div>
</template>

<script>
export default {
  name: "PtHeadConfiguration",
  props: {
    configs: {
      type: Array,
      required: true
    }
  },
  methods: {
    moveUp(index) {
      if (index > 0) {
        const prevItem = this.configs[index - 1];
        const currentItem = this.configs[index];
        this.configs.splice(index - 1, 1, currentItem);
        this.configs.splice(index, 1, prevItem);
        this.update();
      }
    },
    moveDown(index) {
      if (index < this.configs.length - 1) {
        const nextItem = this.configs[index + 1];
        const currentItem = this.configs[index];
        this.configs.splice(index + 1, 1, currentItem);
        this.configs.splice(index, 1, nextItem);
        this.update();
      }
    },
    addItem() {
      this.configs.push({ active: true, reinitTimeStart: "07:30" });
      this.update();
    },
    removeItem(removeIndex) {
      this.configs.splice(removeIndex, 1);
      this.update();
    },
    update() {
      this.$emit("update");
    },
  }
};
</script>
